import { Checkbox, FormControlLabel, FormLabel, MenuItem, TextField } from '@mui/material';
import { Control, Controller, FieldErrors, UseFormSetValue } from 'react-hook-form';
import { FC, useEffect, useState } from 'react';
import { CreateProjectDto } from '@mottmac-moata/identity-sdk';
import { UserAPI } from '@/services/api/UserAPI';

interface ProjectCollectionControllersProps {
  control: Control<Partial<CreateProjectDto>>;
  setValue: UseFormSetValue<Partial<CreateProjectDto>>;
  isMutationLoading: boolean;
  errors: FieldErrors<Partial<CreateProjectDto>>;
}

const ProjectCollectionControllers: FC<ProjectCollectionControllersProps> = ({
  control,
  isMutationLoading,
  setValue,
  errors,
}) => {
  const [isCreateProjectCollection, setIsCreateProjectCollection] = useState(false);
  useEffect(() => {
    if (isCreateProjectCollection) {
      setValue('projectCollectionId', undefined);
    } else {
      setValue('projectCollectionName', undefined);
    }
  }, [setValue, isCreateProjectCollection]);
  const { data: projectCollections } = UserAPI.useFetchProjectCollections();
  return (
    <>
      <FormLabel>Collection</FormLabel>
      {isCreateProjectCollection && (
        <Controller
          control={control}
          name="projectCollectionName"
          render={({ field }) => (
            <TextField
              {...field}
              required
              value={field.value ?? ''}
              slotProps={{
                htmlInput: { maxLength: 39 },
              }}
              placeholder="Collection name (3 to 39 characters)"
              aria-label="Collection name"
              label="Collection name"
              disabled={isMutationLoading}
              error={!!errors.projectCollectionName}
              helperText={errors.projectCollectionName ? errors.projectCollectionName.message : undefined}
            />
          )}
        />
      )}
      {!isCreateProjectCollection && (
        <Controller
          control={control}
          name="projectCollectionId"
          render={({ field }) => (
            <TextField
              {...field}
              disabled={isMutationLoading}
              select
              required
              label="Collection"
              aria-label="Collection"
              value={field.value ?? ''}
              error={!!errors.projectCollectionId}
              helperText={errors.projectCollectionId ? errors.projectCollectionId.message : undefined}
            >
              {projectCollections?.map((projectCollection) => (
                <MenuItem key={projectCollection.name} value={projectCollection.projectCollectionId}>
                  {projectCollection.name}
                </MenuItem>
              )) ?? <span />}
            </TextField>
          )}
        />
      )}
      <FormControlLabel
        control={
          <Checkbox
            checked={isCreateProjectCollection ?? false}
            disabled={isMutationLoading}
            onChange={(e) => setIsCreateProjectCollection(e.target.checked)}
            color="primary"
            size="small"
          />
        }
        label="Create a new Collection"
      />
    </>
  );
};

export default ProjectCollectionControllers;
